(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gpc-homepage"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
function installBoxMotion(root, signal) {
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const cleanups = [];
  root.querySelectorAll('.art-link').forEach(host => {
    const media = host.querySelector('.box-art');
    if (!media) return;
    const video = media.tagName === 'VIDEO';
    let hovered = false, focused = false, tapped = false, active = false, canvas = null;
    const originalVisibility = media.style.visibility;
    const layoutCanvas = () => {
      if (!canvas) return;
      canvas.style.left = media.offsetLeft + 'px';
      canvas.style.top = media.offsetTop + 'px';
      canvas.style.width = media.offsetWidth + 'px';
      canvas.style.height = media.offsetHeight + 'px';
    };
    const freeze = () => {
      if (video || !media.complete || !media.naturalWidth) return;
      if (!canvas) {
        canvas = document.createElement('canvas');
        canvas.className = 'gpc-box-still';
        canvas.setAttribute('aria-hidden','true');
        host.appendChild(canvas);
      }
      canvas.width = media.naturalWidth;
      canvas.height = media.naturalHeight;
      try { canvas.getContext('2d').drawImage(media,0,0); }
      catch (_) { canvas.remove(); canvas = null; return; }
      layoutCanvas();
      canvas.hidden = active;
      media.style.visibility = active ? originalVisibility : 'hidden';
    };
    const sync = () => {
      active = !document.hidden && (hovered || focused || tapped);
      host.classList.toggle('is-animating',active);
      if (video) {
        if (active) { const playing = media.play(); if (playing) playing.then(()=>{if(!active) media.pause();}).catch(()=>{}); }
        else media.pause();
      } else if (active) {
        if (canvas) canvas.hidden = true;
        media.style.visibility = originalVisibility;
      } else freeze();
    };
    const stop = () => { hovered = focused = tapped = false; sync(); };
    if (video) {
      media.autoplay = false;
      media.removeAttribute('autoplay');
      media.muted = true;
      media.defaultMuted = true;
      media.loop = true;
      media.pause();
      media.addEventListener('canplay',sync,{signal});
    } else {
      media.addEventListener('load',()=>{if(!active) freeze();},{signal});
      freeze();
    }
    host.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse' && canHover.matches){hovered=true;sync();}},{signal});
    host.addEventListener('pointerleave',()=>{hovered=false;sync();},{signal});
    host.addEventListener('focusin',()=>{if(host.matches(':focus-visible')){focused=true;sync();}},{signal});
    host.addEventListener('focusout',()=>{focused=false;sync();},{signal});
    host.addEventListener('click',event=>{if(!canHover.matches){event.preventDefault();tapped=!tapped;sync();}},{signal});
    host.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();stop();host.blur();}},{signal});
    document.addEventListener('visibilitychange',()=>{if(document.hidden)stop();},{signal});
    window.addEventListener('pageshow',stop,{signal});
    window.addEventListener('blur',stop,{signal});
    let observer;
    if (typeof ResizeObserver !== 'undefined') { observer = new ResizeObserver(layoutCanvas); observer.observe(media); }
    cleanups.push(()=>{observer?.disconnect();if(video)media.pause();if(canvas)canvas.remove();media.style.visibility=originalVisibility;});
  });
  signal.addEventListener('abort',()=>cleanups.forEach(fn=>fn()),{once:true});
}

  const instances = new WeakMap();
  function initialise(root) {
    if (!root) return;
    instances.get(root)?.abort();
    const controller = new AbortController();
    instances.set(root, controller);
    const signal = controller.signal;
    const menu = root.querySelector('.menu-toggle');
    const nav = root.querySelector('#navigation');
    const closeMenu = () => { nav.classList.remove('is-open'); menu.setAttribute('aria-expanded','false'); menu.setAttribute('aria-label','Open navigation'); };
    menu.addEventListener('click', () => { const open = nav.classList.toggle('is-open'); menu.setAttribute('aria-expanded',String(open)); menu.setAttribute('aria-label',open?'Close navigation':'Open navigation'); }, {signal});
    nav.addEventListener('click', event => { if(event.target.closest('a')) closeMenu(); }, {signal});
    document.addEventListener('keydown', event => { if(event.key==='Escape') closeMenu(); }, {signal});
    installBoxMotion(root, signal);

  }
  const boot=()=>initialise(document.getElementById('gpc-homepage'));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',event=>initialise(event.target.querySelector('#gpc-homepage')));
  document.addEventListener('shopify:section:unload',event=>{const root=event.target.querySelector('#gpc-homepage');if(root)instances.get(root)?.abort();});
})();

  } catch(e) { console.error(e); }
})();
})();
